import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Layout from "../layouts/Layout";
import Divider from "@material-ui/core/Divider";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import MenuItem from "@material-ui/core/MenuItem";
import {
  primaryShade1,
  primaryShade3,
  primaryShade2,
  grey,
  red
} from "../styles/color";
import ExifOrientationImg from "react-exif-orientation-img";
let platform = "other";
if (window.cordova && window.device.platform === "iOS") {
  platform = "ios";
}

const styles = theme => ({
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(0deg)"
  },
  avatar: {
    backgroundColor: red
  },
  colorSwitchBase: {
    color: primaryShade3,
    "&$colorChecked": {
      color: primaryShade1,
      "& + $colorBar": {
        backgroundColor: primaryShade1
      }
    }
  },
  colorBar: {},
  colorChecked: {}
});
const ITEM_HEIGHT = 45;
const ITEM_PADDING_TOP = 10;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4 + ITEM_PADDING_TOP
    }
  }
};
class Invoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      month: [
        {
          monthValue: "01",
          month: "January"
        },
        {
          monthValue: "02",
          month: "February"
        },
        {
          monthValue: "03",
          month: "March"
        },
        {
          monthValue: "04",
          month: "April"
        },
        {
          monthValue: "05",
          month: "May"
        },
        {
          monthValue: "06",
          month: "June"
        },
        {
          monthValue: "07",
          month: "July"
        },
        {
          monthValue: "08",
          month: "August"
        },
        {
          monthValue: "09",
          month: "September"
        },
        {
          monthValue: "10",
          month: "October"
        },
        {
          monthValue: "11",
          month: "November"
        },
        {
          monthValue: "12",
          month: "December"
        }
      ],
      currentMonth: "All",
      date: new Date(),
      currentDate: null,
      checked: true,
      customerDealDetails: [],
      totalQuantity: 0,
      totalRate: 0,
      displayCustomers: [],
      allDeals: [],
      filteredDeals: [],
      customersList: [],
      tempAllCustomers: []
    };
  }
  componentWillMount() {
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  handleActiveCustomerToggle = name => event => {
    this.setState({ checked: event.target.checked }, () =>
      this.initializeData(this.props)
    );
  };
  initializeData = whichProps => {
    let deals = whichProps.allDeals;
    let allCustomers = whichProps.allCustomers;
    let allCustomerDeals = whichProps.allCustomerDeals;
    let customersList = [];
    let tempCustomers = [];
    let tempACDeals = [];
    let tempIACDeals = [];
    let tempDeals = [];
    let middleManData = [];
    let validInActiveDeals = allCustomerDeals.filter(
      customerDeals => customerDeals.isInvoicePaid === true
    );
    validInActiveDeals = validInActiveDeals.filter(function(element) {
      return element !== undefined;
    });
    validInActiveDeals = [...new Set(validInActiveDeals)];
    validInActiveDeals.map(vDeals => {
      if (deals.length > 0) {
        let tDeals = deals.find(deals => deals.id === vDeals.dealId);
        tempIACDeals.push(tDeals);
      }
      return tempIACDeals;
    });

    tempIACDeals = [...new Set(tempIACDeals)];

    let validActiveDeals = allCustomerDeals.filter(
      customerDeals => customerDeals.isInvoicePaid === false
    );
    validActiveDeals = validActiveDeals.filter(function(element) {
      return element !== undefined;
    });
    validActiveDeals = [...new Set(validActiveDeals)];

    validActiveDeals.map(vDeals => {
      if (deals.length > 0) {
        let tDeals = deals.find(deals => deals.id === vDeals.dealId);
        tempACDeals.push(tDeals);
      }
      return tempACDeals;
    });
    tempACDeals = [...new Set(tempACDeals)];

    tempDeals = this.state.checked === true ? tempACDeals : tempIACDeals;
    middleManData =
      this.state.checked === true ? validActiveDeals : validInActiveDeals;

    middleManData = middleManData.filter(function(element) {
      return element !== undefined;
    });

    tempDeals = tempDeals.filter(function(element) {
      return element !== undefined;
    });
    let tempAllCustomers = [];

    middleManData.map(customerDeals => {
      let all = allCustomers.find(
        customers => customers.id === customerDeals.customerId
      );
      tempAllCustomers.push(all);
      return tempAllCustomers;
    });
    tempAllCustomers = tempAllCustomers.filter(function(element) {
      return element !== undefined;
    });
    tempAllCustomers = [...new Set(tempAllCustomers)];
    if (tempAllCustomers.length > 0) {
      if (deals.length > 0) {
        tempAllCustomers.map(customers => {
          let quantity = 0;
          let brokerage = 0;
          const a = customers;
          tempDeals
            .filter(
              deals =>
                deals.buyerId === customers.id ||
                deals.sellerId === customers.id
            )
            .map(deals => {
              if (customers.id === deals.buyerId) {
                quantity += parseInt(deals.quantity);
                brokerage += parseInt(deals.buyerBrokerage);
              }
              if (customers.id === deals.sellerId) {
                quantity += parseInt(deals.quantity);
                brokerage += parseInt(deals.sellerBrokerage);
              }
              return { quantity, brokerage };
            });
          a.quantity = quantity;
          a.brokerage = brokerage;
          tempCustomers.push(a);
          customersList = [...new Set(tempCustomers)];
          let tempCustomer = customersList.filter(cList => cList.brokerage > 0);
          this.setState({ customersList: tempCustomer });
          return customersList;
        });
      } else {
        this.setState({ customersList });
      }
    } else {
      this.setState({ customersList: "" });
    }
  };
  handleChange = name => event => {
    this.setState({ currentMonth: event.target.value });
    this.props.applyDateFilter(event.target.value);
  };

  handleExpandClick = index => {
    this.setState(state => ({
      expanded: index === this.state.expanded ? false : index
    }));
  };

  render() {
    const { month, currentMonth, checked, customersList } = this.state;
    const { classes } = this.props;
    return (
      <Layout
        position="fixed"
        bottomNavigation={true}
        appBar
        appBarTitle={"INVOICE"}
        appBarRightIcon={true}
        selectedValue={1}
      >
        {" "}
        <div
          style={{
            marginTop: "65px"
          }}
        >
          <div
            id="main"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              fontSize: "0.8em",
              height: "25px",
              paddingBottom: "10px"
            }}
          >
            <div
              id="1"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "40%"
              }}
            >
              <span style={{ marginRight: "10px" }}>Month</span>
              <span>
                <Select
                  value={currentMonth}
                  onChange={this.handleChange("currentMonth")}
                  inputProps={{
                    name: "month",
                    id: "month"
                  }}
                  MenuProps={MenuProps}
                  style={{
                    fontSize: "0.8em",
                    color: primaryShade1,
                    autoWidth: "true"
                  }}
                >
                  <MenuItem value="All">All</MenuItem>
                  {month.map(data => (
                    <MenuItem value={data.monthValue}>{data.month}</MenuItem>
                  ))}
                  ;
                </Select>
              </span>
            </div>
            <div
              id="2"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "60%"
              }}
            >
              <span>Show Only Active Customers</span>
              <span>
                <Switch
                  checked={checked}
                  onChange={this.handleActiveCustomerToggle("checked")}
                  value="checked"
                  classes={{
                    switchBase: classes.colorSwitchBase,
                    checked: classes.colorChecked,
                    bar: classes.colorBar
                  }}
                />
              </span>
            </div>
          </div>
          <div
            style={{
              height: "calc(100vh - 138px)",
              overflow: "scroll"
            }}
          >
            {customersList.length > 0 ? (
              customersList.map((data, index) => (
                <div style={{ margin: "0px 10px 0px 10px" }}>
                  <Card style={{ borderRadius: "10px" }}>
                    <CardContent
                      style={{ padding: "0px" }}
                      onClick={e => {
                        e.preventDefault();
                        this.props.history.push(
                          `/invoice/${data.id}/InvoiceDetail`
                        );
                      }}
                      aria-expanded={this.state.expanded}
                      aria-label="View All"
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          width: "100%"
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                            width: window.cordova ? "90px" : "55px",
                            height: "55px",
                            overflow: "hidden"
                          }}
                        >
                          {!data.imageURL ? (
                            <span
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                width: "100%",
                                background: primaryShade2,
                                color: "black",
                                fontSize: "1.70em"
                              }}
                            >
                              {data.name
                                ? data.name.charAt(0).toUpperCase()
                                : ""}
                            </span>
                          ) : platform === "ios" ? (
                            <img
                              alt={data.name.charAt(0).toUpperCase()}
                              src={data.imageURL}
                              style={{
                                height: "100%",
                                width: "100%"
                              }}
                            />
                          ) : (
                            <ExifOrientationImg
                              src={data.imageURL}
                              style={{
                                height: "100%",
                                width: "100%",
                                imageOrientation: `from-image`
                              }}
                              alt={data.name.charAt(0).toUpperCase()}
                            />
                          )}
                        </div>
                        <div
                          style={{
                            flexDirection: "column",
                            justifyContent: "space-around",
                            width: "90%",
                            padding: "10px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "inline-block"
                          }}
                        >
                          <div
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              fontSize: "1.1em"
                            }}
                          >
                            <span>{data.name}</span>
                          </div>
                          <span
                            style={{
                              display: "flex",
                              paddingTop: "3px",
                              justifyContent: "space-between"
                            }}
                          >
                            <span
                              style={{
                                maxWidth: "auto",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "inline-block",
                                color: grey,
                                fontSize: "0.9em"
                              }}
                            >
                              {data.address}
                            </span>
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            borderRadius: "10px",
                            justifyContent: "space-around",
                            alignItems: "center",
                            width: "135px",
                            height: "60px",
                            backgroundColor: primaryShade2
                          }}
                        >
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              width: "100px"
                            }}
                          >
                            <span>Total</span>
                          </span>
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              width: "100%",
                              flexDirection: "column",
                              fontSize: "0.8em"
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <span>{parseInt(data.quantity)} Ton</span>
                            </span>
                            <Divider
                              style={{
                                borderBottom: "2px dotted black",
                                marginRight: "5px",
                                height: "2px",
                                width: "90%"
                              }}
                            />
                            <span
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                                alignItems: "center"
                              }}
                            >
                              <span>&#8377; {data.brokerage}</span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                  <br />
                </div>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  height: "40px",
                  justifyContent: "space-around",
                  alignItems: "center"
                }}
              >
                <h3
                  style={{
                    position: "fixed",
                    bottom: "100px",
                    top: "48%",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  No Invoices Paid Yet...
                </h3>
              </div>
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

Invoice.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(Invoice));
